import React from 'react';
import { Link } from 'react-router';
import styles from './styles.scss';

function WhatIsDC () {
  return (
    <div className="row">
      <div className="col-md-9 col-center">
          <h1 className="bold-italics blue text-center mb50">
            What is DesignCue?
          </h1>
          <p className="bold ls1">
            Easy app design by designers with years of experience and a passion
            for startups.
          </p>
          <p className="ls1 mt30">
            Starting a company is hard, and finding the right talent to make
            your idea a reality is the hardest part. Even if you find a good
            designer, who's to say they'll care enough to work hard for your
            startup?
          </p>
          <p className="ls1 mt30">
            The only way to build great apps and great websites is to combine
            real-world experience with talent and hard work. That's why&nbsp;
            <span className="bold">
              each client has a dedicated product manager and at least one designer.
            </span>
          </p>
          <p className="ls1 mt30 mb50">
            The talent is there. The effort is there.&nbsp;
            <span className="bold">
              Now you have the resources to build a great startup.
            </span>
          </p>
          <Link to="/get-started" className={`${styles.choose} btn btn-dc-primary btn-xs-block`}>
            SUBMIT A BRIEF
          </Link>
      </div>
    </div>
  );
}

export default WhatIsDC;



// WEBPACK FOOTER //
// ./src/components/WhatIsDC/index.js